import './assets/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { VueQueryPlugin } from '@tanstack/vue-query'

import App from './App.vue'
import router from './router'
import rtConfig from '@/configs/runtime'

import {
  create as createNaive,
  NAlert,
  NButton,
  NCard,
  NConfigProvider,
  NDataTable,
  NFlex,
  NGradientText,
  NIcon,
  NInput,
  NInputGroup,
  NInputGroupLabel,
  NButtonGroup,
  NLayout,
  NLayoutSider,
  NLayoutHeader,
  NLayoutContent,
  NMenu,
  NModal,
  NResult,
  NSpace,
  NTag,
} from 'naive-ui'

// Ensure runtime configuration is loaded before app initialization
// So that it can be used in the app components
rtConfig
  .fetchConfigs()
  .then(() => {
    const app = createApp(App)

    app.use(createPinia())
    app.use(router)
    app.use(VueQueryPlugin)
    app.use(
      createNaive({
        components: [
          NAlert,
          NButton,
          NCard,
          NConfigProvider,
          NDataTable,
          NFlex,
          NButtonGroup,
          NLayout,
          NLayoutSider,
          NLayoutHeader,
          NLayoutContent,
          NMenu,
          NModal,
          NIcon,
          NInput,
          NInputGroup,
          NInputGroupLabel,
          NGradientText,
          NResult,
          NSpace,
          NTag,
        ],
      }),
    )
    app.mount('#app')
  })
  .catch((error) => {
    console.error('Failed to fetch runtime configuration:', error)
    // Optionally, handle the error by showing a message to the user
    // or falling back to default values, add them later.
  })
